module.exports = __webpack_public_path__ + "img/bg.7538b23b.png";